import React from 'react';

const LOGO_PATH = 'M14.5 3.8L9.5 5.1C9.1 5.2 8.8 5.7 8.9 6.1C9.1 6.5 9.4 6.7 9.8 6.7L11.4 6.3L7.8 9.9L5.3 8.9C4.9 8.7 4.5 8.9 4.3 9.2L0.9 12.6C0.6 12.9 0.6 13.4 0.9 13.7C1.1 13.9 1.3 14 1.5 14C1.7 14 2 13.9 2.1 13.7L5.2 10.6L7.7 11.6C8.4 11.7 8.6 11.6 8.8 11.4L12.7 7.5L12.3 9.4C12.2 9.8 12.4 10.2 12.8 10.3C13.2 10.4 13.6 10.1 13.8 9.7L15.5 3.6Z';

const CarIcon = () => (
    <svg width="100" height="52" viewBox="0 0 100 52" fill="none" aria-hidden="true">
        <ellipse cx="50" cy="50" rx="38" ry="3" fill="rgba(0,0,0,0.35)"/>
        <rect x="8" y="22" width="84" height="22" rx="6" fill="#1B3A6B"/>
        <path d="M28 22 C30 10 38 8 50 8 C62 8 70 10 72 22 Z" fill="#254e8f"/>
        <path d="M33 22 C34 14 40 11 50 11 C60 11 66 14 67 22 Z" fill="rgba(135,180,255,0.18)"/>
        <rect x="88" y="28" width="6" height="6" rx="2" fill="#FFD215"/>
        <rect x="6" y="28" width="4" height="6" rx="1.5" fill="#ff4444" opacity="0.8"/>

        <g className="car-wheel-front">
            <circle cx="72" cy="40" r="10" fill="#FFC709"/>
            <circle cx="74" cy="40" r="10" fill="#FFD215"/>
            <path transform="translate(64,31) scale(0.85)" fill="white" d={LOGO_PATH}/>
        </g>

        <g className="car-wheel-rear">
            <circle cx="28" cy="40" r="10" fill="#FFC709"/>
            <circle cx="30" cy="40" r="10" fill="#FFD215"/>
            <path transform="translate(20,31) scale(0.85)" fill="white" d={LOGO_PATH}/>
        </g>
    </svg>
);

export default CarIcon;